export const META_TYPE = 'buildOverview';
export const META_VER = 'v1';

export const CMD_BUILDOVERVIEW_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
